module.exports = __webpack_public_path__ + "static/media/disc-drive.7a828d4f.svg";